export var NSFunctions = {	
	
	
	bIE: (window.ActiveXObject)? true: false, //(document.implementation && document.implementation.createDocument) -> Mozilla, Firefox, Opera, etc.
	//	bFireFox: (navigator.userAgent.indexOf("Firefox") >= 0)? true : false, // Kiuwan p n usar "navigator.userAgent"

	getCentroidFromCoordinates: function (coordinates) {
		if (!Array.isArray(coordinates)) return;
		
		if (coordinates.length === 2 && !Array.isArray(coordinates[0])) return coordinates;

		const centroidTotal = {x: 0, y: 0};

		for (const coord of coordinates) {
			const [x, y] = NSFunctions.getCentroidFromCoordinates(coord);

			centroidTotal.x += x;
			centroidTotal.y += y;
		}

		return [centroidTotal.x / coordinates.length, centroidTotal.y / coordinates.length];
	},

	getViewPortHeightWidth: function () 
	{     
		var viewportwidth;  
	  var viewportheight;     
	  // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight     
	  if (typeof window.innerWidth != 'undefined')  
	  {       
		viewportwidth = window.innerWidth;       
		viewportheight = window.innerHeight;  
	  }    
	  // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)    
	  else if (typeof document.documentElement != 'undefined'     
		&& typeof document.documentElement.clientWidth !=      'undefined' 
		&& document.documentElement.clientWidth != 0)  
	  {        
		viewportwidth = document.documentElement.clientWidth;        
		viewportheight = document.documentElement.clientHeight;  
	  }     
	  // older versions of IE     
	  else 
	  {        
		viewportwidth = document.getElementsByTagName('body')[0].clientWidth;        
		viewportheight = document.getElementsByTagName('body')[0].clientHeight;  
	  } 
		return { height: viewportheight, width: viewportwidth }; 
	},
	
	getElementAbsoluteHeight: function(el) 
	{
		var styles = window.getComputedStyle(el);
		var margin = parseFloat(styles['marginTop']) +
		parseFloat(styles['marginBottom']);

		//return Math.ceil(el.offsetHeight + margin); -> offsetHeight will return rounded integer
		return Math.ceil( parseFloat(styles['height']) + margin);
	},

	getElementAbsoluteWidth: function(el) 
	{
		var styles = window.getComputedStyle(el);
		var margin = parseFloat(styles['marginLeft']) +
		parseFloat(styles['marginRight']);

		//return Math.ceil(el.offsetHeight + margin); -> offsetHeight will return rounded integer
		return Math.ceil( parseFloat(styles['width']) + margin);
	},

	/**
	 * @description height available for content (excludes padding top; padding bottom; scrollbar-x height)
	 */
	getElementContentAvailableHeight: function(el) 
	{
		var styles = window.getComputedStyle(el);
		var padding = parseFloat(styles['paddingTop']) +
		parseFloat(styles['paddingBottom']);

		return Math.floor(el.clientHeight - padding);//clientHeight excludes scrollbar height
	},

	getElementAbsoluteHeight_even_if_element_has_never_been_rendered: function(el) 
	{

		let f_get_height_while_forcing_element_to_be_rendered_at_least_once = function()
		{
			let o_parent_old = el.parentElement;
			let s_visibility_old = el.style.visibility;
			el.style.visibility = "hidden";
			document.body.appendChild(el);
			var height = el.offsetHeight;//el.offsetHeight + 0;
			document.body.removeChild(el);
			el.style.visibility = s_visibility_old;
			o_parent_old.appendChild(el);
			return height;
		}

		let height = (el.offsetHeight==0)? 
						f_get_height_while_forcing_element_to_be_rendered_at_least_once()
						: el.offsetHeight;

		var styles = window.getComputedStyle(el);
		var margin = parseFloat(styles['marginTop']) +
		parseFloat(styles['marginBottom']);

		//console.log("height:"+ height + "margin:"+ margin)
		return Math.ceil(height + margin);
	},
	
	convertRemToPixels: function(rem) {    
	    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
	},
	
	convertHexColorToRgb: function(hex) {
		let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result ? {
			r: parseInt(result[1], 16),
			g: parseInt(result[2], 16),
			b: parseInt(result[3], 16)
		} : null;
	},

	//limita casas decimais
	//n -> num a arredondar
	//iCD -> num max de casas decimais
	roundNumber: function (n, iCD) 
	{
		return Math.round(n*Math.pow(10,iCD))/Math.pow(10,iCD);
	},

	//obj -> Id do elemento a encontrar
	//array -> array alvo da pesquisa
	//fEqual(o1,o2) - o1->obj - o2->elemento da lista a comparar numa iteração
	getArrayPos: function (obj, array, fEqual)
	{
		if(array)
			for(var i = 0; i < array.length; i++)
			{
				if(fEqual(obj, array[i]))
					return i;

			};

		return -1;
	},

	//there's no way to generate real GUIDs in Javascript, this function generates a random id that looks like a GUID
	guidGenerator: function () 
	{
		var S4 = function() {
		   return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
		};
		return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
	},

	//------------------------------------------------------------------------------------------------
	//returns true if HTML Class list string has the passed class
	
	elemClass_HasClass: function (sClassesList, sClass)
	{
		/*
		if(sClassesList.indexOf(sClass)>-1)
			return true;
		else
			return false;
		*/
		let a_ = sClassesList.split(" ");
		if(a_.indexOf(sClass)>-1)
		{ return true; }
		else
		{ return false; }

	},
	//returns a string, with the passed class(sClass) removed from the HTML Class list string(sClassesList)
	elemClass_RemoveClass: function (sClassesList, sClass)
	{
		/*
		sClassesList = sClassesList.replace(sClass, "");
		sClassesList = sClassesList.replace("  ", "");
		*/

        // Split the class list into an array, filter out the class name, and join it back into a string
		let new_classes_list = sClassesList
            .split(' ')
            .filter(className => className !== sClass)
            .join(' ');

		return new_classes_list;
	  
	},
	elemClass_addClass: function (sClassesList, sClass)
	{
	  
		if( !this.elemClass_HasClass(sClassesList, sClass) )
		{
			sClassesList = (sClassesList.length > 0)? sClassesList + " " + sClass : sClass;
		}
		
		return sClassesList;
	  
	},
	
	removeValueFromArray: function(oArray , oValue)
	{
		var a = oArray;
		for(var i=0; i<a.length; i++)
		{
			if(a[i] == oValue)
			{
				a.splice(i,1);
				return;
			}
		}

	},

	StringReplaceAll: function (s, search, replacement)
	{
		var target = s;
		
		//reg expression	-> faster
		return target.replace(new RegExp(search, 'g'), replacement);
		//alternative
		//return target.split(search).join(replacement);
	},
	
	f_stringIsNullOrEmpty: function (str) {
	    return (!str || 0 === str.length);
	},
	
	f_stringHasContent: function (str) {
	    return !(this.f_stringIsNullOrEmpty(str));
	},

	getScrollTop: function ()
	{
		var i_scroll = document.documentElement.scrollTop || document.body.scrollTop;
		return i_scroll;
		
	},

	//returns a string, with the passed class(sClass) removed from the HTML Class list string(sClassesList)
	elemCSSClass_RemoveClass: function (sClassesList, sClass)
	{
		sClassesList = sClassesList.replace(sClass, "");
		sClassesList = sClassesList.replace("  ", "");
		return sClassesList;
	  
	},
	elemCSSClass_addClass: function (sClassesList, sClass)
	{
		sClassesList = (sClassesList.length > 0)? sClassesList + " " + sClass : sClass;
		return sClassesList;  
		
	},
	
	/** @description adds sClass if it is not present on element's class list */
	elem_addClass: function (e_, sClass)
	{
		/*
		var sClassesList = ( e_.getAttribute("class") != null )? e_.getAttribute("class") : "";
		sClassesList = NSFunctions.elemCSSClass_addClass(sClassesList, sClass)
		e_.setAttribute("class", sClassesList)
		return sClassesList;  
		*/
		if(! e_.classList.contains(sClass) )
		{
			e_.classList.add(sClass);
		}
		
	},
	elem_removeClass: function (e_, sClass)
	{
		/*
		var sClassesList = ( e_.getAttribute("class") != null )? e_.getAttribute("class") : "";
		sClassesList = NSFunctions.elemCSSClass_RemoveClass(sClassesList, sClass)
		e_.setAttribute("class", sClassesList)
		return sClassesList;  
		*/
		e_.classList.remove(sClass);


	},
	elem__hasClass: function (e_, sClass)
	{
		/*
		var sClassesList = ( e_.getAttribute("class") != null )? e_.getAttribute("class") : "";
		var b_has_class = NSFunctions.elemClass_HasClass(sClassesList, sClass);
		*/
		let b_has_class = e_.classList.contains(sClass);
		return b_has_class;  

	},

	f_elem_fade: function fade(element, f_cb_on_complete) {
		let op = 1;  // initial opacity
		let timer = setInterval(function () {
			if (op <= 0.1){
				clearInterval(timer);
				element.style.display = 'none';
				op = 0;
				if(f_cb_on_complete) { f_cb_on_complete(); }
				
			}
			element.style.opacity = op;
			//element.style.filter = 'alpha(opacity=' + op * 100 + ")";
			op -= op * 0.1;
		}, 50);
	},

	f_elem_unfade: function (element, f_cb_on_complete) {
		let op = 0.1;  // initial opacity
		element.style.display = '';
		let timer = setInterval(function () {
			if (op >= 1){
				clearInterval(timer);
				op = 1;
				if(f_cb_on_complete) { f_cb_on_complete(); }
			}
			element.style.opacity = op;
			//element.style.filter = 'alpha(opacity=' + op * 100 + ")";
			op += op * 0.1;
		}, 10);
	},

/* KIUWAN ACHAVA QUE PODIA HAVER AQUI UM LOOP INFINITO
	f_dom_elem_append_dom_childs_by_html: function (elem, s_html)
	{
		var e_div_ = document.createElement("div");
		e_div_.innerHTML = s_html;
		var a_elements = e_div_.childNodes;
		while(a_elements.length>0)
		{
			var e_0 = a_elements[0];
			elem.appendChild(e_0);
		}
	
	},
*/
	f_load_css: function(s_url)
	{
		var link = document.createElement("link");
		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = s_url;
		document.getElementsByTagName("head")[0].appendChild(link);
		
	},
	
	f_remove_css: function(s_url)
	{

		
		let e_head = document.getElementsByTagName("head")[0];
		let a_e_link = e_head.getElementsByTagName("link")
		for(let i=0; i<a_e_link.length; i++)
		{
			let e_link_i = a_e_link[i];
			let s_link_i_url = e_link_i.getAttribute("href");
			if(s_link_i_url == s_url)
			{
				e_head.removeChild(e_link_i)
				return;
			}
			
		}
		
	},
	
	// returns true if o_date is a valid date
	//o_date -> new Date("some string");
	f_check_if_date_is_valid: function(o_date)
	{
		var b_result;
		var d = o_date;

		if (Object.prototype.toString.call(d) === "[object Date]") {
			//it is a date
			if (isNaN(d.getTime()))  // d.valueOf() could also work 
			{
				// date is not valid
				b_result = false;
			} else 
			{
				// date is valid
				b_result = true;
			}
		} else {
			// not a date
			b_result = false;
		}

		return b_result;
		
	},
	
	o_comparisson_struct:
	{
		//table sort functions:
		//compare select HTML
		f_cmp_sel : function(o1_in, o2_in)
		{
			/*
			var f_find_select_value_desc = function(s_select)
			{
				var s_= s_select;
				var e_ = document.createElement('tmp');
				e_.innerHTML = s_;
				var a_ = e_.getElementsByTagName('option');
				for(var i=0; i< a_.length; i++)
				{
					var e_i = a_[i];
					if (e_i.hasAttribute('selected'))
					{
						return e_i.innerHTML;
					}
				}
			}
			*/
			var f_find_select_value_desc = function(s_select)
			{
				var s_= s_select;
				// "...selected="selected"...>VALUE_DESC</option>..."
				//var i = s_.indexOf('selected="selected"')
				var s1 = s_.split('selected="selected"')[1];
				var s2 = s1.split("</option>")[0];
				var s_desc = s2.split(">")[1];
				
				return s_desc;
				
			}
			
			var o1 = f_find_select_value_desc(o1_in);
			var o2 = f_find_select_value_desc(o2_in);
			
			//return o1 < o2;
			return this.f_cmp_string(o1, o2);
			
			
		},
		//compare input checkbox HTML
		f_cmp_input_cb : function(o1_in, o2_in)
		{
		/*
			var f_find_select_value_desc = function(s_input_cb)
			{
				var s_= s_input_cb;
				var e_ = document.createElement('tmp');
				e_.innerHTML = s_;
				var a_ = e_.getElementsByTagName('input');
				
					var e_0 = a_[0];
					if (e_0.hasAttribute('checked'))
					{
						return 1;
					}
					else
					{
						return 0;
					}
			}
			*/
			let f_find_select_value_desc = function (s_input_cb)
			{
				if (s_input_cb.indexOf("checked") >-1)
				{
					return 1;
				}
				else
				{
					return 0;
				}
			}
			
			var o1 = f_find_select_value_desc(o1_in);
			var o2 = f_find_select_value_desc(o2_in);
			
			return o1 < o2;
			
			
		},
		
		//simple comparissons:
		f_cmp_string : function (o1, o2)
		{
			var b_int = false;
			return this.f_cmp_string_or_int(o1, o2, b_int);
		},
		f_cmp_int : function (o1, o2)
		{
			var b_int = true;
			return this.f_cmp_string_or_int(o1, o2, b_int);
		},
		f_cmp_string_or_int : function (o1, o2, b_int)
		{
			var this_ = this;
			var f;
			if(b_int)
			{
				f = function(a,b){
					var i_a = (parseInt(a))? parseInt(a) : "Not a number";
					var i_b = (parseInt(b))? parseInt(b) : "Not a number";
					
					if(i_b == "Not a number")
					{
						return -1;
					}
					else if(i_a == "Not a number")
					{
						return 1;
					}
					else if(i_a>=i_b)
					{
						return 1;
					}
					else
					{
						return -1;
					}
				}
			}
			else
			{
				f = function(a,b){
					var s_a = a + "";
					var s_b = b + "";
				
					/*
					if(s_a>=s_b)
					{
						return 1;
					}
					else
					{
						return -1;
					}
					*/
					return this_.f_text_comparison(s_a, s_b);
				}
			
			}
			
			return f(o1,o2);
		},
		f_text_comparison : function (s_1_param, s_2_param)
		{
			var f_format_s = function(s)
			{
				s = s.toLowerCase();

				s = NSFunctions.StringReplaceAll(s, "à","a");
				s = NSFunctions.StringReplaceAll(s, "á","a");
				s = NSFunctions.StringReplaceAll(s, "â","a");
				s = NSFunctions.StringReplaceAll(s, "ã","a");
				s = NSFunctions.StringReplaceAll(s, "è","e");
				s = NSFunctions.StringReplaceAll(s, "é","e");
				s = NSFunctions.StringReplaceAll(s, "ê","e");
				s = NSFunctions.StringReplaceAll(s, "ì","i");
				s = NSFunctions.StringReplaceAll(s, "í","i");
				s = NSFunctions.StringReplaceAll(s, "î","i");
				s = NSFunctions.StringReplaceAll(s, "ò","o");
				s = NSFunctions.StringReplaceAll(s, "ó","o");
				s = NSFunctions.StringReplaceAll(s, "ô","o");
				s = NSFunctions.StringReplaceAll(s, "õ","o");
				s = NSFunctions.StringReplaceAll(s, "ù","u");
				s = NSFunctions.StringReplaceAll(s, "ú","u");
				s = NSFunctions.StringReplaceAll(s, "û","u");
				
				return s;
			}
		
			var s_1 = f_format_s(s_1_param);
			var s_2 = f_format_s(s_2_param);
			/*
			var i_res = (s_1 > s_2)? 1 : -1;
			return i_res;	
			*/
			return s_1 < s_2;
			
		}
	
	},
	
	//treats content as text by default
	f_sort_array: function (array_in, b_int)
	{
		var f;
		if(b_int)
		{
			f = function(a,b){
				var i_a = (parseInt(a))? parseInt(a) : "Not a number";
				var i_b = (parseInt(b))? parseInt(b) : "Not a number";
				
				if(i_b == "Not a number")
				{
					return -1;
				}
				else if(i_a == "Not a number")
				{
					return 1;
				}
				else if(i_a>=i_b)
				{
					return 1;
				}
				else
				{
					return -1;
				}
			}
		}
		else
		{
			f = function(a,b){
				var s_a = a + "";
				var s_b = b + "";
			
				/*
				if(s_a>=s_b)
				{
					return 1;
				}
				else
				{
					return -1;
				}
				*/
				return o_comparisson_struct.f_text_comparison(s_a, s_b);
			}
		
		}
		
		array_in.sort(f);
	},

	//	ex: f_hex_to_rgb('#FF0000', 0.5);
	f_hex_to_rgb: function (hex, alpha) {
		let r = parseInt(hex.slice(1, 3), 16),
			g = parseInt(hex.slice(3, 5), 16),
			b = parseInt(hex.slice(5, 7), 16);
	
		if (!isNaN(Number(alpha))) {
			return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
		} else {
			return "rgb(" + r + "," + g + "," + b + ")";
		}
	},

	f_dom_elem_append_dom_childs_by_html: function (elem, s_html)
	{
		
		
		const parser = new DOMParser();
		const newNode = parser.parseFromString(s_html, 'text/html');
		const a_elements = newNode.documentElement.querySelectorAll('body')[0].childNodes

		const fragment = document.createDocumentFragment();
		let a_nodes_inserted = [];
		for (let index = 0; index < a_elements.length; index++) 
		{
			let e_i = a_elements[index];
			fragment.appendChild(e_i);  
		  
		  if (e_i.nodeName !== '#text' && e_i.innerHTML !== undefined)
			  a_nodes_inserted.push(e_i);
		}
		elem.appendChild(fragment);

		return a_nodes_inserted.length === 1 ? a_nodes_inserted[0] : a_nodes_inserted;
		
		/* OLD VERSION:
		var e_div_ = document.createElement("div");
		e_div_.innerHTML = s_html;
		var a_elements = e_div_.childNodes;
		var a_nodes_inserted = [];
		
		while(a_elements.length>0)
		{
			var e_0 = a_elements[0];
			elem.appendChild(e_0);

			if (e_0.nodeName !== '#text' && e_0.innerHTML !== undefined)
				a_nodes_inserted.push(e_0);
		}

		return a_nodes_inserted.length === 1 ? a_nodes_inserted[0] : a_nodes_inserted;
		*/

	},

	f_dom_elem_preappend_dom_childs_by_html: function (elem, html, opt_selector)
	{
		var e_div_ = typeof html === 'string' ? document.createElement("div") : html;
		
		if (typeof html === 'string') e_div_.innerHTML = html;

		var a_elements = e_div_.childNodes;
		var e_opt_element = typeof opt_selector === 'string' ? elem.querySelector(opt_selector) : null;
		var a_nodes_inserted = [];

		for(let i = a_elements.length - 1; i >= 0; i--)
		{
			var e_0 = a_elements[i];

			if (elem.childNodes.length === 0) elem.appendChild(e_0);
			else if (e_opt_element === null) elem.insertBefore(e_0, elem.childNodes[0]);
			else elem.insertBefore(e_0, e_opt_element);

			if (e_0.nodeName !== '#text' && e_0.innerHTML !== undefined)
				a_nodes_inserted.push(e_0);
		}

		return a_nodes_inserted.length === 1 ? a_nodes_inserted[0] : a_nodes_inserted;
	},


	f_string_remove_all_duplicate_spaces: function(s_input)
	{
		return s_input.replace(/\s+/g,' ');
	},

	f_check_input_type_number_support: function()
	{
		var f_checkInput = function (type) {
			var input = document.createElement("input");
			input.setAttribute("type", type);
			return input.type == type;
		}
		
		return f_checkInput("number");
	},

	f_check_input_type_date_support: function()
	{
		var f_checkInput = function (type) {
			var input = document.createElement("input");
			input.setAttribute("type", type);
			return input.type == type;
		}
		
		return f_checkInput("date");
	}
}



window.NSFunctions_ = NSFunctions;